// import { bootstrap } from 'bootstrap';
import AccordionImages from "../components/events-accordion/events-accordion.js";
import Calendar from "../components/calendar/calendar.js";
import Header from "../components/header/header.js";
import HeroImage from "../components/hero-image/hero-image.js";
import MessageModal from "../components/modal-message/modal-message.js";
import ScrollTo from '../components/scroll-to-id/scroll-to-id.js';
import EventSwiper from "../components/event/event-swiper.js";
import Press from "../components/press/press.js";
import Spotlights from "../components/spotlights/spotlights.js";
import SwiperEvents from "../components/swiper-events/swiper-events.js";
import SwiperImageCarousel from "../components/image-carousel/image-carousel.js";
import SwiperInteractive from "../components/swiper-interactive/swiper-interactive.js";
import SwiperSocials from "../components/swiper-socials/swiper-socials.js";
import SwiperNews from "../components/swiper-news/swiper-news.js";
import SwiperPartners from "../components/swiper-partners/swiper-partners.js";
import SwiperSingle from "../components/swiper-single/swiper-single.js";
import TeamMembers from "../components/team-members/team-members.js";
import TitleDropDownImages from "../components/titles-dropdown-image/titles-dropdown-image.js";
import Video from '../components/video/video.js';
import VideoSection from "../components/video-section/video-section.js";
import VideoScrollingText from '../components/video-scrolling-text/video-scrolling-text.js';
import VideoTypewriter from '../components/video-typewriter/video-typewriter.js';
import ImageCarousel from "../components/image-carousel/image-carousel.js";

console.log('%cWDC - Let\'s Rock!', 'color: green; font-size: 13px');


if (document.querySelector(".events-accordion")) {
  let accordionImages = new AccordionImages();
  accordionImages.init();
}

if (document.querySelector(".calendar-module")) {
  let calendar = new Calendar();
  calendar.init();
}

if (document.querySelector(".hero-image")) {
  let heroImage = new HeroImage();
  heroImage.init();
}

if (document.querySelector(".modal-message")) {
  let messageModal = new  MessageModal();
  messageModal.init();
}

if (document.querySelector(".navbar")) {
  let header = new Header();
  header.init();
}

if (document.querySelector(".press-module")) {
  let press = new Press();
  press.init();
}

if (document.querySelector(".scroll-to") || document.querySelector(".scroll-to-next")) {
  let scrollTo = new ScrollTo();
  scrollTo.init();
}

if (document.querySelector(".spotlights")) {
  let spotlights = new Spotlights();
  spotlights.init();
}

if (document.querySelector(".swiper--event")) {
  let eventSwiper = new EventSwiper();
  eventSwiper.init();
}

if (document.querySelector(".swiper-events")) {
  let swiperEvents = new SwiperEvents();
  swiperEvents.init();
}

if(document.querySelector(".swiper--image-carousel")) { 
  let swiperImageCarousel = new SwiperImageCarousel();
  swiperImageCarousel.init();
}

if (document.querySelector(".swiper-interactive")) {
  let swiperInteractive = new SwiperInteractive();
  swiperInteractive.init();
}

if (document.querySelector(".swiper-socials")) {
  let swiperSocials = new SwiperSocials();
  swiperSocials.init();
}

if (document.querySelector(".swiper-news")) {
  let swiperNews = new SwiperNews();
  swiperNews.init();
}

if (document.querySelector(".swiper-partners")) {
  let swiperPartners = new SwiperPartners();
  swiperPartners.init();
}

if (document.querySelector(".swiper-single")) {
  let swiperSingle = new SwiperSingle();
  swiperSingle.init();
}

if (document.querySelector(".team-members")) {
  let teamMembers = new TeamMembers();
  teamMembers.init();
}

if (document.querySelector(".titles-dropdown-image")) {
  let titleDropDownImages = new TitleDropDownImages();
  titleDropDownImages.init();
}

if (document.querySelector(".video")) {
  let video = new Video();
  video.init();
}

if (document.querySelector(".video-section")) {
  let videoSection = new VideoSection();
  videoSection.init();
}

if (document.querySelector(".video-scrolling-text")) {
  let videoScrollingText = new VideoScrollingText();
  videoScrollingText.init();
}

if (document.querySelector(".video-typewriter")) {
  let videoTypewriter = new VideoTypewriter();
  videoTypewriter.init();
}